module.exports = __webpack_public_path__ + "media/3_syutanno_kaouteisu_danzaisya.2dabc94a.mp3";